export enum STORAGE_KEY {
  REFRESH_TOKEN = 'refreshToken',
  JWT_BEARER_TOKEN = 'jwtBearerToken',

  //organization
  ORGANIZATION_ID = 'organizationId',
  ORGANIZATION_EVENT_ID = 'organizationEventId',
  ORGANIZATION_EVENT = 'organizationEvent',
  //user

  USER_ID = 'userId',

  //notificationSetting
  USER_NOTIFICATION_SETTING = 'userNotificationSetting',
  ORGANIZATION_NOTIFICATION_SETTING = 'organizationNotificationSetting',

  //superAdmin
  SUPER_ADMIN_ID = 'superAdminId',

  // organization role
  ORGANIZATION_ROLE = 'organizationRole',

  //team memberId
  TEAM_MEMBER_ID = 'teamMemberId',

  REPORTS_TABLE_SELECTED_COLUMNS = 'reportsTableSelectedColumns',

  //slug
  ORGANIZATION_EVENT_SLUG = 'organizationEventSlug',

  //private purchase token
  PRIVATE_PURCHASE_TOKEN = 'privatePurchaseToken',
}
